import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { WORKSPACE_SIDEBAR_AVATAR_CLASS } from './workspace-layout';
import { useWorkspaceSidebar } from './WorkspaceSidebarContext';

function getAuthInitials(): string {
  try {
    const raw =
      sessionStorage.getItem('qtrace-auth') ??
      localStorage.getItem('qtrace-auth');
    if (!raw) return 'U';
    const session = JSON.parse(raw) as {
      name?: string;
      email?: string;
      user_id?: string;
    };
    const label = session.name || session.email || session.user_id || '';
    return String(label).substring(0, 2).toUpperCase() || 'U';
  } catch {
    return 'U';
  }
}

const SidebarUserMenu = () => {
  const { closeMobile } = useWorkspaceSidebar() ?? {};

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          className={WORKSPACE_SIDEBAR_AVATAR_CLASS}
          aria-label="Open profile menu">
          {getAuthInitials()}
        </Button>
      </PopoverTrigger>
    </Popover>
  );
};

export default SidebarUserMenu;
